import { MolsonBox, MolsonIcon, MolsonTypography } from '@components/reusable'

type ArchivedNotificationProps = {
  id?: string
  text: string
}

export const ArchivedNotification = ({
  id,
  text
}: ArchivedNotificationProps) => {
  return (
    <MolsonBox
      alignItems="center"
      display="flex"
      gap={0.5}
      id={id}
      mt={0.5}
      dataTestId="archived-notification"
    >
      <MolsonIcon variant="ERROR_OUTLINE" iconColor="error" />
      <MolsonTypography variant="error">{text}</MolsonTypography>
    </MolsonBox>
  )
}
